// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { TelegramChatMessageModel, TelegramChatModel } from '../../symbols';

export interface TelegramChatStateModel {
  chatList: PaginatorModel<TelegramChatModel>;
  loadChatListStatus: PROGRESS_STATUSES;
  unreadMessagesCount?: number;
  messages: {[chatId: string]: PaginatorModel<TelegramChatMessageModel>}
}

export const TELEGRAM_CHAT_STATE_DEFAULT: TelegramChatStateModel = {
  chatList: {
    data: [],
    meta: null,
    links: null,
  },
  loadChatListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  unreadMessagesCount: 0,
  messages: {}
};
